import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";

export const usePrebillPaymentInformationViewModel = ({
  attempt,
  stateManager,
}) => {
  const [billingCommitments, setBillingCommitments] = useState([]);

  const getBillingCommitments = () => {
    stateManager.run(async () => {
      const response = await accountService.billingCommitments.getAll({
        filters: {
          homeId: {
            eq: { type: "guid", value: attempt?.home?.id },
          },
          orderId: {
            eq: { type: "guid", value: attempt?.orderId },
          },
        },
        params: {
          includeDraftInvoices: true,
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setBillingCommitments(response.data);
      }
    });
  };

  const deleteBillingCommitment = ({ id, modifiedOn, type }) => {
    stateManager.run(async () => {
      const response = await accountService.billingCommitments.delete({
        id,
        modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${type} payment information was deleted successfully.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        getBillingCommitments();
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    billingCommitments,
    getBillingCommitments,
    deleteBillingCommitment,
  };
};
